import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
	companyConfig: state.company_config.detail,
});

export function withCompanyConfig(Component: React.ComponentType<any>) {
	return connect(mapStateToProps)(Component);
}
